import { useMemo } from 'react';
import { useAppSelector } from '@/stores/hooks';

export type SidebarAppItem = {
  id: string;
  code: string;
  name: string;
  icon?: string | null;
  order?: number;
};

export function useSortedApps(): SidebarAppItem[] {
  const user = useAppSelector((state) => state.auth.user);

  return useMemo(() => {
    if (!user?.apps?.groups) {
      return [];
    }

    const allApps = user.apps.groups.flatMap(
      (group: { apps: SidebarAppItem[] }) => group.apps
    );

    return allApps.sort(
      (a: SidebarAppItem, b: SidebarAppItem) => (a.order ?? 0) - (b.order ?? 0)
    );
  }, [user?.apps?.groups]);
}
